import { render, staticRenderFns } from "./UofTQuiz1Question2.vue?vue&type=template&id=4a67c2b8&"
import script from "./UofTQuiz1Question2.vue?vue&type=script&lang=ts&"
export * from "./UofTQuiz1Question2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFileInput,VForm,VRow})
